import clsx from 'clsx'
import * as React from 'react'

import { Spinner } from '@/app/components/Elements/Spinner'

const variants = {
    primary: 'bg-primary text-white',
    inverse: 'bg-white text-blue-600',
    danger: 'bg-red-600 text-white',
}

const sizes = {
    sm: 'py-2 px-4 text-sm',
    md: 'py-2 px-6 text-md',
    lg: 'py-4 px-4 max-w-xs w-full mx-auto',
}

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    variant?: keyof typeof variants
    size?: keyof typeof sizes
    isLoading?: boolean
    className?: string
    disabled?: boolean
}

const Button = (props:ButtonProps) => {
    return(
        <button type={props.type}
            className={clsx(
                'flex justify-center items-center border border-gray-300 disabled:opacity-70 disabled:cursor-not-allowed rounded-lg shadow-sm font-bold focus:outline-none hover:opacity-80',
                variants[props.variant ?? "primary"],
                sizes[props.size ?? "md"],
                props.className,
                )}
            {...props}
            disabled={props.disabled ?? false}
            >
            {props.isLoading && <Spinner size="sm" className="text-current" />}
            <span className="mx-2">{props.children}</span>
        </button>
    )
}

export default Button